import {getAppSessionCookieHeader} from "../appCookie";
import api from "../../Api";
import {handleError} from "../Utils";

export const getCompanyTasks =  async () => {
  const resp = await api.get('tasks/company' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });
  return resp;
}

export const archiveTask =  async (task) => {
  const resp = await api.post('tasks/remove' + getAppSessionCookieHeader(), task).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });
  return resp;
}

export const getTaskDefinition =  async () => {
  const resp = await api.get('tasks/def' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });
  return resp;
}

export const saveTask =  async (task) => {
  const resp = await api.post('tasks/save' + getAppSessionCookieHeader(), task).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });
  return resp;
}